import React from "react";
import { Link } from "react-router-dom";
import { Download, LineChart, Loader2, Plus, Upload } from "lucide-react";
import LeadsMenu from "./LeadsMenu";

// AUTO-CRM-32: Stage page header for the lead list. Overview numbers moved to
// Insights; "Go to table" stays for long pages and keyboard users.
export default function LeadsHeader({ workspaceId, pipelineName, total, loading = false, onAddLead, onImportLeads, onExportLeads, exporting = false, onTableClick }) {
  return (
    <header className="crm-page-head ws-rise crm-leads-head">
      <div className="ws-grow">
        <div className="ws-eyebrow">Leads{pipelineName ? <><span className="crm-eyebrow-dot" />{pipelineName}</> : null}</div>
        <div className="crm-leads-titleline">
          <h1 className="ws-title">Leads</h1>
          <span className="crm-count-pill ws-num" aria-label={loading ? "Loading lead count" : `${total} leads`}>{loading ? "…" : Number(total || 0).toLocaleString("en-IN")}</span>
        </div>
        <p className="ws-muted">Every enquiry in this pipeline, with its stage, owner and next step.</p>
      </div>
      <div className="crm-page-actions">
        <button type="button" className="ws-btn ws-btn--plain crm-skip" onClick={onTableClick} aria-label="Go to table">Skip to table</button>
        <Link className="ws-btn ws-btn--quiet" to="/insights"><LineChart size={15} />Insights</Link>
        <button type="button" onClick={onImportLeads} disabled={!workspaceId} className="ws-btn ws-btn--quiet"><Upload size={15} />Import</button>
        <button type="button" onClick={onExportLeads} disabled={!workspaceId || exporting} className="ws-btn ws-btn--quiet" aria-label={exporting ? "Exporting leads" : "Export leads"}>{exporting ? <Loader2 size={15} className="ws-spin" /> : <Download size={15} />}Export</button>
        <button type="button" onClick={onAddLead} className="ws-btn ws-btn--primary"><Plus size={16} />Add lead</button>
        <LeadsMenu workspaceId={workspaceId} />
      </div>
    </header>
  );
}
